// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2-cQK","footer":"ModalInfo_footer__2dLCO"};